export const audienceConfig = {
    max: {
        keywords: 3000,
        domains: 500,
        urlsBlackList: 500,
    }
}
